// extracted by mini-css-extract-plugin
export default {"vimeoIcon":"_daHny"};